var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolWrap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2361",
    "data-name": "Group 2361",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.473,
    height: 27.461,
    viewBox: "0 0 29.473 27.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 29.473,
    height: 27.461,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M331.795,253.835a3.133,3.133,0,0,1-1.318,2.009,3.019,3.019,0,1,1-1.568-5.533,3.082,3.082,0,0,1,2.834,2.3c.017.065.035.129.052.193Zm-3-1.546a1.006,1.006,0,0,0-1.03,1.039,1.034,1.034,0,0,0,1.045,1.063,1.08,1.08,0,0,0,1.063-1.066,1.04,1.04,0,0,0-1.078-1.036",
    transform: "translate(-302.322 -232.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M106.367,287.806c.731-.017,1.159.32,1.2.814a.966.966,0,0,1-.868,1.116q-3.989.582-7.979,1.16-3.251.475-6.5.957a1.007,1.007,0,0,1-1.184-.792.961.961,0,0,1,.816-1.127c1.142-.187,2.288-.347,3.434-.515q2.47-.362,4.941-.72l4.572-.664,1.568-.229",
    transform: "translate(-84.461 -267.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M0,48.942A3.037,3.037,0,0,1,3.02,45.955a3.025,3.025,0,0,1,3,3.04,2.964,2.964,0,0,1-2.994,3A2.97,2.97,0,0,1,0,48.942m4.048.046a1.006,1.006,0,0,0-1.018-1.05,1.05,1.05,0,1,0-.04,2.1,1.027,1.027,0,0,0,1.057-1.048",
    transform: "translate(0.001 -42.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M5.331,303.385A3,3,0,0,1,2.5,300.172a3.057,3.057,0,0,1,3.262-2.8,3.022,3.022,0,0,1,2.766,3.116,2.981,2.981,0,0,1-3.2,2.9m-.859-3a1.029,1.029,0,0,0,1.049,1.057,1.069,1.069,0,0,0,1.051-1.04,1.03,1.03,0,0,0-1.047-1.061,1.008,1.008,0,0,0-1.053,1.044",
    transform: "translate(-2.314 -275.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M237.159,6.042A3.04,3.04,0,0,1,234.095,3a3.024,3.024,0,0,1,6.047.03,3.061,3.061,0,0,1-2.983,3.009m-.041-1.98A1.027,1.027,0,0,0,238.17,3.01a1.051,1.051,0,0,0-1.038-1.048,1.035,1.035,0,0,0-1.06,1.048,1.013,1.013,0,0,0,1.045,1.052",
    transform: "translate(-217.229 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M289.52,97.539a1,1,0,0,1-.734.925.944.944,0,0,1-1.065-.434,8.5,8.5,0,0,1-.524-1.335q-1.5-4.071-2.984-8.147c-.039-.108-.082-.215-.111-.326a.98.98,0,0,1,.6-1.212.965.965,0,0,1,1.24.587c.238.606.454,1.221.677,1.832q1.382,3.777,2.763,7.555a1.555,1.555,0,0,1,.134.555",
    transform: "translate(-263.598 -80.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M30.9,145c0,.632,0,1.264,0,1.9a.98.98,0,0,1-.96,1.041.992.992,0,0,1-.979-1.05c-.072-1.867-.019-3.735-.064-5.6-.028-1.149-.039-2.3-.041-3.447a.97.97,0,0,1,1.9-.3,2.331,2.331,0,0,1,.074.6c.012.747.015,1.494.016,2.241q0,2.312,0,4.625H30.9",
    transform: "translate(-26.772 -127.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M96.347,40.191a.975.975,0,1,1,.261,1.933c-.581.12-1.164.23-1.746.344q-3.168.623-6.335,1.248a1.142,1.142,0,0,1-1.057-.188.9.9,0,0,1-.314-.955A1,1,0,0,1,88,41.817c.685-.136,1.37-.269,2.056-.4l6-1.176c.122-.024.245-.039.289-.046",
    transform: "translate(-80.845 -37.295)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolWrap);
export default __webpack_public_path__ + "static/media/icon_tool_wrap.a8463fc145b4c62d1eeca85be7b498d2.svg";
export { ForwardRef as ReactComponent };